import type { ChartCheckHandler } from './checkIfSelected.types';
import type { DataVizRow } from '../../../DataViz.types';

export const getSelfKey = (item?: DataVizRow): string | undefined =>
  Object.keys(item ?? {}).find((key) => item?.[key] === key);

export const getKeyItem = (key: string, grouping_key?: string): DataVizRow => ({ [grouping_key ?? key]: key });

export const checkIfSelected: ChartCheckHandler = (
  item,
  _type,
  selected,
  props,
): true | false | undefined => {
  if (selected === undefined) return undefined;
  const grouping_key = props?.grouping_key;
  if (!grouping_key) {
    const self_key = getSelfKey(item);
    if (!self_key) return undefined;
    return Boolean(selected[self_key]?.some((value) => String(value) === self_key));
  }
  const list = selected[grouping_key];
  if (!Array.isArray(list) || !list.length) return undefined;
  const group = item?.[grouping_key];
  return group !== undefined && list.some((value) => String(value) === String(group));
};
